import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  stepperContainer: {
    margin: '0 auto',
    maxWidth: '800px',
  },
}));

export default useStyles;
